<template>
    <div v-if="visible" class="modal-overlay">
      <div class="modal-container modal-full-width">
        <!-- Cabeçalho com o título e ícone de fechamento -->
        <div class="modal-header">
          <h6>Aplicar Avaliação</h6>
          <i class="bi bi-x-circle close-icon" @click="fecharModal"></i>
        </div>
        <div class="spacer"></div>
  
        <!-- Corpo do Modal (conteúdo) -->
        <div class="modal-content">
          <!-- Seção com dados do período -->
          <div class="card-body mb-3">
            <h6>Dados da Avaliação</h6><p></p>
            <p>
              <strong>Avaliação:</strong> {{ periodo.nome }}<br>
              <strong>Início:</strong> {{ globalUtils.formatarData(periodo.data_inicio) }}<br>
              <strong>Fim:</strong> {{ globalUtils.formatarData(periodo.data_fim) }}
            </p>
          </div>
          <!-- Seção com tabela de níveis e formulários de prova -->
          <div class="card-body">
            <h6>Níveis e Formulários de Prova</h6><p></p>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nível</th>
                  <th>Formulário de Prova</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(assoc, index) in associacoes" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ assoc.nivelNome }}</td>
                  <td>{{ assoc.formularioNome }}</td>
                </tr>
                <tr v-if="!associacoes || associacoes.length === 0">
                  <td colspan="3" class="text-center">Nenhuma associação registrada.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  
        <!-- Rodapé com botões de ação -->
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="fecharModal">Cancelar</button>
          <button
            :class="['btn', aplicando ? 'btn-success' : 'btn-primary']"
            @click="aplicarAvaliacao"
            :disabled="aplicando"
          >
            {{ aplicando ? 'Aplicando' : 'Aplicar' }}
          </button>
        </div>
      </div>
    </div>
  </template>
  
<script>
import axios from '@/services/axios';
import { ref } from 'vue';
import globalUtils from "@/utils/globalUtils.js";


export default {
  name: 'ModalAplicarAvaliacao',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // Objeto com os dados do período, esperado no mesmo formato utilizado no formulário
    periodo: {
      type: Object,
      required: true
    },
    // Array com as associações já "enriquecidas" (ex.: [{ nivelNome, formularioNome }, ...])
    associacoes: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const aplicando = ref(false);

    const aplicarAvaliacao = async () => {
      if (aplicando.value) return;
      aplicando.value = true;
      try {
        // Endpoint para efetuar a aplicação; envia o id do período
        // apesar de ser um GET, executa o salvamento dos registros na tabela avaliacoes_periodos_provas
        await axios.get('/cadastros/avaliacoes-periodos/aplicar', {
            params: { id: props.periodo.id }
        });
        // Emite um evento para notificar que a aplicação foi realizada (por exemplo, para atualizar a listagem)
        emit('aplicado');
        fecharModal();
      } catch (error) {
        console.error('Erro ao aplicar avaliação:', error);
        // Aqui você pode exibir uma notificação de erro, se desejar
      } finally {
        aplicando.value = false;
      }
    };

    const fecharModal = () => {
      emit('fechar');
    };

    return { 
        aplicarAvaliacao, 
        fecharModal, 
        aplicando,
        globalUtils,
    };
  }
};
</script>

<style scoped>
/* Estilos inspirados no segundo modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 50%;
  min-height: 70%;
  max-height: 90%;
  overflow-y: auto;
  margin: 0 auto;
  border-radius: 0px;
}

.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.spacer {
  margin-bottom: 20px;
}

.modal-content {
  padding: 10px 15px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}

.btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background-color: #007bff;
  color: #fff;
}

.btn-primary:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.btn-secondary {
  background-color: #6c757d;
  color: #fff;
  margin-right: 10px;
}
</style>
